module.exports = __webpack_public_path__ + "static/media/biodef_logo_big.2c97d7d8.png";